<template>
  <div class="hello">
    <div class="flex flex-col items-center justify-center">
      <Tabs v-model="tab" :tabs="tabs" />
      <div class="p-10">
        <div v-if="tab === 'tab1'">
          Tab 1
        </div>
        <div v-if="tab === 'tab2'">
          Tab 2
        </div>
        <div v-if="tab === 'tab3'">
          Tab 3
        </div>
      </div>
    </div>
    <div class="mx-auto" style="width: 300px;">
      <Row>
        <div slot="left">
          Left
        </div>
        Center
        <div slot="right">
          Right
        </div>
      </Row>
    </div>
    <div>
      <Calendar />
    </div>
    <div>
      <ProgressBar color="secondary" :value="60" class="mx-2 mb-2 h-3">
        <span
          style="font-size: 8px;"
          class="text-xs text-white w-full flex justify-start items-center pl-2"
          >{{ 60 }}%</span
        >
      </ProgressBar>
    </div>
    <div>
      <GridLayout :row-width="500" :gap="16">
        <RecipeCard />
        <RecipeCard />
      </GridLayout>
    </div>
    <div>
      <WeightChart
        id="weight-chart"
        class="overflow-hidden"
        :chart-data="chartData"
        :chart-labels="[
          'Start',
          'Week 1',
          'Week 2',
          'Now',
          'Week 4',
          'Week 5',
          'Week 5',
          'Week 6',
          'Week 7',
          'Week 8',
          'Week 9',
          'Week 10',
          'Week 11',
          'Week 12',
          'Goal'
        ]"
      />
    </div>
    <div class="flex justify-center">
      <KImage
        src="https://images.unsplash.com/photo-1555985202-12975b0235dc"
        style="width: 150px;"
      />
    </div>
    <div class="flex justify-center">
      <Input v-model="name" text label="Username" />
    </div>
    <div class="flex justify-center">
      <Input file label="Credentials" />
    </div>
    <div>
      <GridLayout :row-width="255" :gap="16">
        <MyClientCard
          v-for="client in myClients"
          :key="`my-client-card-${client.id}`"
          :client="client"
          style="width: 255px;"
        />
        <InfiniteLoader v-model="loading" :schema="schema" />
      </GridLayout>
    </div>
    <div class="my-10 py-10 mx-auto border border-solid border-secondary">
      <div>
        <h1 class="pb-5">Full Button</h1>
        <Button disabled @click="login">
          Login
        </Button>
        <Button icon="user-tie" class="mx-10" @click="login">
          Login
        </Button>
        <Button loading @click="login">
          Login
        </Button>
      </div>
      <div class="my-10">
        <h1 class="pb-5">Outline Button</h1>
        <Button outline disabled @click="request">
          Request
        </Button>
        <Button outline icon="user-tie" class="mx-10" @click="request">
          Request
        </Button>
        <Button outline loading @click="request">
          Request
        </Button>
      </div>
      <div>
        <h1 class="pb-1.5">Flat Button</h1>
        <Button flat disabled @click="request">
          Request
        </Button>
        <Button flat icon="user-tie" class="mx-10" @click="request2">
          Request
        </Button>
        <Button flat loading @click="request">
          Request
        </Button>
      </div>
    </div>
    <div class="flex justify-evenly mx-10 my-5">
      <Avatar :size="100" />
      <Avatar src="image2.jpg" :size="100" />
    </div>
    <div class="flex justify-center">
      <Loader :loading="true" />
    </div>
  </div>
</template>

<script>
import ModalTemplate from "@/components/ModalTemplate";
import requestTemplate from "@/utils/requestTemplate.js";
import MyClientCard from "@/pages/MyClients/components/MyClientCard";
import { mapGetters } from "vuex";
// import handleLoading from "@/mixins/handleLoading";
import WeightChart from "@/components/WeightChart";
import Calendar from "@/components/Calendar";
import RecipeCard from "@/pages/MyRecipes/components/RecipeCard";

export default {
  name: "HelloWorld",
  components: {
    MyClientCard,
    WeightChart,
    RecipeCard,
    Calendar
  },
  mixins: [requestTemplate],
  props: {
    msg: String
  },
  computed: {
    chartData() {
      const measurements = [91, 90, 87, 91, 92, 89, 87, 83, 69];
      const duration = 15;
      const goal = measurements[measurements.length - 1];
      const lastMeasurement = measurements[measurements.length - 2];
      const weightDifferenceTillGoal = lastMeasurement - goal;
      const remainingDay = duration - measurements.length + 1;
      const step = weightDifferenceTillGoal / remainingDay;
      let newArray = measurements.splice(0, measurements.length - 1);

      for (let i = 1; i <= remainingDay - 1; i++) {
        newArray.push((lastMeasurement - step * i).toFixed(1));
      }

      newArray.push(goal);

      return newArray;
    },
    ...mapGetters({
      myClients: "getMyClients"
    })
  },
  data() {
    return {
      tab: "tab1",
      tabs: [
        {
          name: "Tab 1",
          value: "tab1"
        },
        {
          name: "Tab 2",
          value: "tab2"
        },
        {
          name: "Tab 3",
          value: "tab3"
        }
      ],
      schema: {
        action: "fetchMyClients",
        getter: "getMyClients",
        pagination: "getMyClientsPagination",
        clean: "resetMyClients"
      },
      loading: false,
      name: "Nikandros"
    };
  },
  methods: {
    login() {
      this.$modal.show(
        ModalTemplate,
        { text: "This text is passed as a property" },
        {
          name: "ModalTemplate",
          draggable: false,
          shiftX: 1.0,
          height: "100%",
          transition: "vm-transition--side-card",
          classes: "rounded-xl rounded-r-none ModalTemplate"
        }
      );
    },
    request() {
      const success = () => {
        this.$notify({
          type: "success",
          group: "foo",
          text: "Fuck yeah!"
        });

        // to override the default notification return true;
        return true;
      };

      const fail = () => {
        alert("I am not gonna override the default notification.");
      };

      this.templateRequest("fetchMyClients", {}, success, fail);
    },
    request2() {
      const data = { name: "Nikandros" };

      this.templateRequest("action2", data);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
